import { AxiosError } from 'axios';
import { AlertType } from 'interfaces';
import { Dispatch } from 'redux';
import { setAlert, showAlert } from 'redux/modules/Alert/alert';
import { IStandardErrorResponseFromBE } from 'services';

export const showErrorAlert = (
  dispatch: Dispatch,
  e: unknown,
  additionMessage: string,
) => {
  const axiosError = e as AxiosError<IStandardErrorResponseFromBE>;
  const data = axiosError.response?.data;

  const statusCode = axiosError.response?.status;
  if (statusCode === 401) {
    return;
  }

  if (data) {
    const { code, errorMessage } = data;

    dispatch(
      setAlert({
        type: AlertType.error,
        title: `${additionMessage}`,
        bodyText: errorMessage,
      }),
    );

    dispatch(showAlert());
  } else {
    dispatch(
      setAlert({
        type: AlertType.error,
        title: additionMessage,
        bodyText: (e as Error).message ?? '',
      }),
    );

    dispatch(showAlert());
  }
};
